import { SimpleDialogContentInstance, SimpleDialogData, TextInputComponent } from '@abovo/shared-ui-components';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { TeamCardRow, TeamRoleRowComponent } from '../../../../../../../features/team/components/team-role-row.component';

/** One remark, and optionally who it goes to. */
export interface RemarkDialogData {
   /** The remark the field opens with. Default empty. */
   remark?: string | null;

   /** Who the remark goes to, shown but not changeable: the message is addressed by whoever handles it. */
   recipient?: TeamCardRow | null;

   /** Whether a remark has to be written before the dialog can be confirmed. Default false. */
   required?: boolean;

   /** Translation keys for the field. Default the intermediate report's own labels. */
   labels?: {
      remark?: string;
      remark_placeholder?: string;
   };
}

@Component({
   selector: 'webvis-ui-intermediate-report-remark-dialog',
   imports: [ReactiveFormsModule, TextInputComponent, TranslatePipe, TeamRoleRowComponent],
   template: `
      @if (data.recipient; as recipient) {
         <webvis-feature-team-role-row
            [disabled]="true"
            [row]="recipient"
         />
      }

      <shared-ui-text-input
         [inputFormControl]="fg.controls.remark"
         [label]="label | translate"
         [placeholder]="placeholder ? (placeholder | translate) : ''"
         type="multi"
      ></shared-ui-text-input>
   `,
})
export class RemarkDialogComponent implements SimpleDialogContentInstance {
   private readonly formBuilder = inject(FormBuilder);
   readonly dialogData: SimpleDialogData<RemarkDialogData> = inject(MAT_DIALOG_DATA);

   protected readonly data: RemarkDialogData = this.dialogData.dialogData ?? {};

   protected readonly label = this.data.labels?.remark ?? 'intermediate_report.remark';
   protected readonly placeholder = this.data.labels?.remark_placeholder ?? null;

   readonly fg = this.formBuilder.group({
      remark: [this.data.remark ?? '', this.data.required ? [Validators.required] : []],
   });
}
